export default __webpack_public_path__ + "static/ch-logo-dark-8216bc5a0221b4b89faa52b019d1a09b.svg";